import React, { FunctionComponent } from 'react'
import { Pane, majorScale, Icon, Text } from 'evergreen-ui'

interface VerifiedPanelProps {
  phoneNumber?: string | null
}

const VerifiedPanel: FunctionComponent<VerifiedPanelProps> = ({ phoneNumber }) => (
  <Pane
    background="tint1"
    alignItems="center"
    padding={majorScale(2)}
    height={majorScale(6)}
    display="flex"
    justifyContent="space-between"
    borderTop="muted"
    borderBottomLeftRadius="5"
    borderBottomRightRadius="5"
  >
    <Pane>
      <Icon icon="tick-circle" color="success" marginRight={majorScale(1)} size={14} />
      <Text size={400}>Verified</Text>
    </Pane>
    {phoneNumber && (
      <Text size={400} color="muted">
        ***-***-{phoneNumber}
      </Text>
    )}
  </Pane>
)

export default VerifiedPanel
